import ClientService from "../services/client.service";

const state = {
	total: 0,
	// clients: [],
	loadingClient: false,
	newClient: null,
	oneClient: null,
	lastName: '',
	id: '',
	item: {},
	itemMemberCard: {},
	items: [],
	itemsForSearch: [],
	generateMemberCardObject: '',
	updateSidebarOneClient: {},
	clientDisCountForPos: null,
	clientItem: {},
	discountForCardResSucces: '',
	listDiscountForCardArray: []

}
const getters = {
	clients: (state) => {
		return state.items
	},
	total: (state) => {
		return state.total;
	},

	getFromModalMemberCard: (state) => {
		return state.item
	},
	generatedMemberCard: (state) => {
		return state.generateMemberCardObject;
	},
	getCurrentClient: (state) => {
		return state.item;

	},
	getCurrentClientFromModal: (state) => {
		return state.item;
	}

}


const actions = {

	async createDiscountForClient({commit}, clientDiscountArray) {
		try {
			const result = await ClientService.discountForCard(clientDiscountArray);
			commit('setResultDiscountForClient', result.data);
			return true;

		} catch (e) {
			return false;
		}
	},
	async deleteDiscountForClient({commit}, item) {
		try {
			const result = await ClientService.deleteDiscountForCard(item);
			commit('setResultDeleteDiscountForClient', result.data);
			return true;

		} catch (e) {
			return false;
		}
	},
	async getAllDiscountForClient({commit}) {
		try {
			const result = await ClientService.listDiscountForCard();
			commit('setResultListDiscountForClient', result.data);
			return true;

		} catch (e) {
			return false;
		}
	},


	async getClientWithId({commit}, clientId) {
		try {
			const getOneClient = await ClientService.getOneClient(clientId);
			commit('setOneClient', getOneClient.data);
			commit('setMemberCardForSideBar', {});
			return true;

		} catch (e) {
			return false;
		}
	},
	async getAllClientsForTable({commit}, searchForm) {
		try {
			commit('setLoadingClient', true);
			const getAllClient = await ClientService.getAllClient(searchForm);
			commit('setAllClientForTable', getAllClient.data);
			commit('setLoadingClient', false);
			return true;

		} catch (e) {
			commit('setLoadingClient', false);
			return false;
		}
	},

	async getAllCLientsForSearchForm({commit}, searchForm) {
		try {
			commit('setLoadingClient', true);
			const getAllClient = await ClientService.getAllClient(searchForm);
			commit('searchClientForSearch', getAllClient.data.items);
			commit('setLoadingClient', false);
			return true;

		} catch (e) {
			commit('setLoadingClient', false);
			return false;
		}
	},
	async searchLastNameStore({commit}, lastName) {
		try {
			commit('setLoadingClient', true);
			const getRes = await ClientService.searchLastName(lastName);
			commit('searchClientForSearch', getRes.data);
			commit('setLoadingClient', false);
			return true;
		} catch (e) {
			commit('setLoadingClient', false);
			return false;

		}
	},

	async getMemberCardStore({commit}, payloadMemberCard) {
		try {
			const getMemberCard = await ClientService.searchMember(payloadMemberCard);
			commit('setMemberCardForSideBar', getMemberCard.data);
			return true;
		} catch (e) {
			return false;
		}
	},

	async generateMemberCardStore({commit}) {

		try {
			const getMemberCard = await ClientService.generateMemberCard();
			commit('setGenerateMemberCard', getMemberCard.data);
			return true;

		} catch (e) {
			return false;
		}

	},

	async deleteCLientStore({commit}, clientId) {
		try {
			const clientResponse = await ClientService.deleteCLient(clientId);
			commit('deleteClient', {clientResponse, clientId});
		} catch (e) {
			return false;
		}
	},

	async saveClientStore({commit}, payloadClient) {
		try {
			const client = await ClientService.saveClient(payloadClient);
			commit('newClient', client.data);
			return true;
		} catch (e) {
			// let response = JSON.parse(e.request.response);
			// commit('createClientError', {message: response.message, boolean: true});
			return false;
		}

	},
	async saveClientItemForPos({commit}, clientItem) {
		commit('setClientItem', clientItem);
	},
	async currentUpdateForClient({commit}, item) {
		commit('setUpdateSidebarOneClientItem', item)
	},
	//SIDEBARDAN SEARCH QILIB TANLANGAN CLIENT NI SET QILISH UCHUN
	async setCurrentClient({commit}, item) {
		await commit('setMemberCard', item);
		if (item.memberCardDiscount) {
			await commit('pos/setMemberCardForDiscount', item.memberCardDiscount, {root: true});
		}
	},
	emptyObjectStore({commit}, emptyObject) {
		commit('setMemberCardForSideBar', emptyObject);
		commit('setClientItem', emptyObject);
	},
	//Client ni create qilgandan kn  Sidebardan set qilingan klentni tozalash un
	emptyObjectClientSidebar({commit}, emptyObject) {
		// commit('setMemberCard', emptyObject);
		commit('setClientItem', emptyObject);
	},
	//Bu Bo'sh obyekt sidebar orqali qidirilgan clientni topgandan kn create dan kelganini pustoy qilish uchun
	emptyOjbectClientFromModalSidebar({commit}, emptyObject) {
		// commit('setMemberCard', emptyObject);
		commit('setMemberCard', emptyObject);

	}
}
const mutations = {
	setLoadingClient(state, boolean) {
		state.loadingClient = boolean;
	},

	setResultDiscountForClient(state, response) {
		state.discountForCardResSucces = response;
	},
	setResultDeleteDiscountForClient(state, response) {
	},
	setResultListDiscountForClient(state, listDiscountForCardArray) {
		state.listDiscountForCardArray = listDiscountForCardArray;
	},
	setOneClient(state, clientObject) {
		state.oneClient = clientObject;
		state.item = clientObject;
	},
	setUpdateSidebarOneClientItem(state, item) {
		state.updateSidebarOneClient = item;
	},

	setAllClientForTable(state, res) {
		state.items = res.items;
		state.total = res.total;
	},
	//CREATE CLIENT QILGANDAN KN CLIENT NI SET QILIB CLIENT FOR POS DA CHIQARISH UN
	setClientItem(state, clientItem) {
		state.item = clientItem;
	},

	setMemberCard(state, item) {
		state.item = item;
	},
	setGenerateMemberCard(state, item) {
		state.generateMemberCardObject = item;
	},
	resetCurrentClient(state) {
		state.item = {}
		state.clientItem = {}
		state.itemMemberCard = {}
	},
	setMemberCardForSideBar(state, item) {
		state.itemMemberCard = item;
	},

	searchClientForSearch(state, items) {
		state.itemsForSearch = items;
	},
	searchLastNameStore(state, res) {
		state.items = res;
	},


	deleteClient(state, obj) {
		if (obj.deleteResponse) {
			let foundIndex = state.clients.findIndex(x => x.id == payload.id);
			state.clients.splice(foundIndex, 1);
		}
	},

	newClient(state, addedClient) {
		state.newEmployee = addedClient;
	},

}
export const clients = {
	namespaced: true,
	getters,
	state,
	actions,
	mutations
}

